import { EMPTY_FIELD } from 'constants/emptyField';

import { RaRecord } from 'react-admin';
import {
  DEFAULT_DATE_MASK,
  DEFAULT_TIME_MASK,
  DEFAULT_TIMEZONE,
} from 'shared/mui/DatePicker/config/defaultValues';
import { Stack } from 'shared/mui/Stack/Stack';
import { Typography } from 'shared/mui/Typography';
import { FunctionField, FunctionFieldProps } from 'shared/react-admin/Fields';
import { formatInputInTz } from 'utils/date';

export type DateTimeFieldProps = {
  label?: string | React.ReactElement;
  source: string;
  timezone?: string;
  dateMask?: string;
  timeMask?: string | false;
  inline?: boolean;
  transform?: (value: number) => Date;
} & Omit<FunctionFieldProps, 'render'>;

export const DateTimeField: React.FC<DateTimeFieldProps> = ({
  label,
  source,
  transform,
  timezone = DEFAULT_TIMEZONE,
  dateMask = DEFAULT_DATE_MASK,
  timeMask = DEFAULT_TIME_MASK,
  inline = false,
  ...rest
}) => {
  return (
    <FunctionField
      label={label}
      render={(record: RaRecord) => {
        if (!record[source]) {
          return EMPTY_FIELD;
        }
        const date = transform?.(record[source]) || new Date(record[source]);
        return (
          <Stack direction={inline ? 'row' : 'column'}>
            <Typography variant="body2">{`${formatInputInTz(date, { timezone, format: dateMask })}`}</Typography>
            {inline && ',\u00A0'}
            {timeMask && (
              <Typography color={inline ? 'inherit' : 'secondary.main'} variant="body2">
                {`${formatInputInTz(date, { timezone, format: timeMask })}`}
              </Typography>
            )}
          </Stack>
        );
      }}
      {...rest}
    />
  );
};
